export default __webpack_public_path__ + "popup-close-icon.svg";